export enum AuthModalPageEnums {
  LOG_IN = 'LOG_IN',
  SIGN_UP = 'SIGN_UP',
}

export enum AuthModalMethodEnums {
  WEB3,
  TRADITIONAL,
}
